import { render, staticRenderFns } from "./WidgetDefault.vue?vue&type=template&id=deb134b8"
import script from "./WidgetDefault.vue?vue&type=script&lang=js"
export * from "./WidgetDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports